var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.65926 9.77358L1.64594 8.76024C1.2326 8.3469 1.2326 7.6669 1.64594 7.25356L2.65926 6.24022C2.8326 6.06688 2.9726 5.72688 2.9726 5.48688V4.05353C2.9726 3.46686 3.4526 2.98688 4.03927 2.98688H5.4726C5.7126 2.98688 6.0526 2.8469 6.22593 2.67357L7.23926 1.66022C7.65259 1.24689 8.3326 1.24689 8.74593 1.66022L9.75928 2.67357C9.93261 2.8469 10.2726 2.98688 10.5126 2.98688H11.9459C12.5326 2.98688 13.0126 3.46686 13.0126 4.05353V5.48688C13.0126 5.72688 13.1526 6.06688 13.3259 6.24022L14.3393 7.25356C14.7526 7.6669 14.7526 8.3469 14.3393 8.76024L13.3259 9.77358C13.1526 9.94692 13.0126 10.2869 13.0126 10.5269V11.9602C13.0126 12.5469 12.5326 13.0269 11.9459 13.0269H10.5126C10.2726 13.0269 9.93261 13.1669 9.75928 13.3402L8.74593 14.3536C8.3326 14.7669 7.65259 14.7669 7.23926 14.3536L6.22593 13.3402C6.0526 13.1669 5.7126 13.0269 5.4726 13.0269H4.03927C3.4526 13.0269 2.9726 12.5469 2.9726 11.9602V10.5269C2.9726 10.2803 2.8326 9.94025 2.65926 9.77358Z",
    stroke: "#3D8C40",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10L10 6",
    stroke: "#3D8C40",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66268 9.66671H9.66867",
    stroke: "#3D8C40",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32967 6.33333H6.33566",
    stroke: "#3D8C40",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.6aa37da2b25f11e2cea0dc7e49abc130.svg";
export { ForwardRef as ReactComponent };